import { provideObjClass } from 'scrivito'

import { defaultPageAttributes } from '../defaultPageAttributes'

export const Page = provideObjClass('Page', {
  attributes: {
    ...defaultPageAttributes,
    body: 'widgetlist',
    data: 'datalocator',
    excludeFromSearch: 'boolean',
    hideInNavigation: 'boolean',
    linkIcon: 'string',
    showAsLandingPage: 'boolean',
  },
  extractTextAttributes: ['body'],
})
